module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "careers-top-right.e81702b1.jpeg" + "?" + Date.now();